import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Footer from "../Component/Footer";

function HelpDesk() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
    acceptedTerms: false,
  });

  const firstOrders = [
    {
      id: 1,
      que: "What should I prepare for the first pickup?",
      ans: "We aim to collect your clothes, clean them to a professional standard and get them back to you all within 48 hours. If you’d prefer we went a little slower then that’s not a problem – just let us know when you want your clothes back.",
    },
    {
      id: 2,
      que: "Why do women’s blouses cost more than men’s shirt?",
      ans: "We aim to collect your clothes, clean them to a professional standard and get them back to you all within 48 hours. If you’d prefer we went a little slower then that’s not a problem – just let us know when you want your clothes back.",
    },
    {
      id: 3,
      que: "Are there any fabrics you don't clean?",
      ans: "While we clean a wide range of fabrics, there are certain materials that may require special care or cannot be cleaned due to their delicate nature. For example, some fabrics like silk, leather, and suede require specialized cleaning methods. Please let us know if you have any items made from such materials, and we will advise the best approach.",
    },
    {
      id: 4,
      que: "Where are my clothes cleaned?",
      ans: "Your clothes are cleaned at our professional facility, which is equipped with the latest cleaning technology and equipment. Our experienced team uses high-quality detergents and processes to ensure your clothes are cleaned to the highest standards. We take great care in handling all types of fabrics to maintain their quality and longevity.",
    },
  ];

  const dryCleaning = [
    {
      id: 1,
      que: "What if my clothes are damaged?",
      ans: "We aim to collect your clothes, clean them to a professional standard and get them back to you all within 48 hours. If you’d prefer we went a little slower then that’s not a problem – just let us know when you want your clothes back.",
    },
    {
      id: 2,
      que: " What all is included in your service?",
      ans: "Our service includes professional cleaning, stain removal, pressing, and folding of your clothes. We also offer free pickup and delivery within a designated area. Our team ensures that each item is treated with care and cleaned according to its specific requirements, whether it's dry cleaning or wash and fold. We aim to provide you with a hassle-free experience from start to finish.",
    },
    {
      id: 3,
      que: "Do you furnish the cleaning supplies?",
      ans: "Yes, we provide all the necessary cleaning supplies for your clothes. Our team uses high-quality detergents, stain removers, and fabric softeners to ensure your items are cleaned to a professional standard. We also provide eco-friendly options for those who prefer a greener cleaning solution. You don’t need to worry about providing anything—just leave it to us!",
    },
  ];

  const WashTumbleFold = [
    {
      id: 1,
      que: "Do I need to weigh my Wash, Tumble Dry & Fold bag?",
      ans: "We aim to collect your clothes, clean them to a professional standard and get them back to you all within 48 hours. If you’d prefer we went a little slower then that’s not a problem – just let us know when you want your clothes back.",
    },
    {
      id: 2,
      que: "What temperature do you wash the clothes at?",
      ans: "The temperature at which we wash clothes depends on the fabric type and the care instructions. For most clothing, we wash at a temperature that ensures effective cleaning while being gentle on the fabric. Typically, this ranges from 30°C to 40°C (86°F to 104°F). For delicate fabrics or specific stains, we may use lower temperatures. We always follow the manufacturer’s care instructions to maintain the integrity of your garments.",
    },
    {
      id: 3,
      que: "Do I get to keep the bag?",
      ans: "The bag provided for your laundry is a convenient way to collect and store your clothes. Typically, the bag is for single use or for the duration of your service. Once your clothes are cleaned and returned, you may be required to return the bag. However, if you'd like to keep the bag, please feel free to ask, and we can make arrangements for you to purchase one.",
    },
  ];

  // Handle form input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Log the form data for now, you can perform actual submission logic here
    console.log("Form submitted:", formData);
  };

  return (
    <>
      <div
        id="subtitle-wrapper"
        className="lazyload"
        data-bg="images/subtitle-wrapper01.jpg"
      >
        <div
          className="subtitle-wrapper-img lazyload"
          data-bg="images/subtitle-wrapper01-img.jpg"
        >
          <div className="container container-fluid-xl">
            <div className="tt-breadcrumbs">
              <ul>
                <li>
                  <a href="index.html">home</a>
                </li>
                <li>Help Desk</li>
              </ul>
            </div>
            <h1 className="subtitle__title">Help Desk</h1>
          </div>
          <div className="bubbleContainer">
            <div className="bubble-1"></div>
            <div className="bubble-2"></div>
            <div className="bubble-3"></div>
            <div className="bubble-4"></div>
            <div className="bubble-5"></div>
            <div className="bubble-6"></div>
            <div className="bubble-7"></div>
            <div className="bubble-8"></div>
            <div className="bubble-9"></div>
            <div className="bubble-10"></div>
          </div>
        </div>
      </div>
      <main id="tt-pageContent">
        <div
          className="lazyload subpage-bg-left subpage-bg__position07"
          data-bg="images/wrapper-subpage-left07.png"
        >
          <div
            className="lazyload subpage-bg-right subpage-bg__position07"
            data-bg="images/wrapper-subpage-right07.png"
          >
            <div className="section-indent">
              <div className="container container-fluid-lg">
                <div className="title-block text-center">
                  <div className="title-block__label">
                    [ Frequently Asked Questions ]
                  </div>
                  <h4 className="title-block__title">
                    Reliable Answers to Our Most
                    <br className="d-none d-sm-block" />
                    Common Questions
                  </h4>
                  <div className="title-block__text tt-limit-width03">
                    We can save you money on soap, water, heating and
                    electricity. So you can enjoy even more of the things you
                    love. Our prices are simple and affordable.
                  </div>
                </div>
                <div
                  className="row-indent-top"
                  style={{ marginBottom: "30px" }}
                >
                  <h6 className="tt-subtitle">Your First Order!</h6>
                  <div className="row">
                    {firstOrders.map((obj) => (
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "10px" }}
                        key={obj.id}
                      >
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                          >
                            <Typography>{obj.que}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>{obj.ans}</Typography>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="row-indent-top"
                  style={{ marginBottom: "30px" }}
                >
                  <h6 className="tt-subtitle">Dry Cleaning</h6>
                  <div className="row">
                    {dryCleaning.map((obj) => (
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "10px" }}
                        key={obj.id}
                      >
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                          >
                            <Typography>{obj.que}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>{obj.ans}</Typography>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="row-indent-top"
                  style={{ marginBottom: "30px" }}
                >
                  <h6 className="tt-subtitle">Wash, Tumble Dry & Fold</h6>
                  <div className="row">
                    {WashTumbleFold.map((obj) => (
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "10px" }}
                        key={obj.id}
                      >
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                          >
                            <Typography>{obj.que}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>{obj.ans}</Typography>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="section-inner">
              <div className="container container-fluid-lg">
                <div className="title-block text-center">
                  <h4 className="title-block__title">Ask Your Question</h4>
                  <div className="title-block__text tt-limit-width">
                    We look forward to helping you create and maintain a clean,
                    healthy environment that’s as enjoyable as it is functional.
                  </div>
                </div>
                <div className="row justify-content-md-center">
                  <div className="col-md-9 col-lg-8">
                    <form
                      className="form-default form-default__top text-center"
                      id="faq-form"
                      onSubmit={handleSubmit}
                    >
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="row row-align-col">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="E-mail"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              name="phoneNumber"
                              className="form-control"
                              placeholder="Phone"
                              value={formData.phoneNumber}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <textarea
                          name="message"
                          rows="4"
                          className="form-control"
                          placeholder="Your question"
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                      <div className="form-group">
                        <div className="checkbox-group">
                          <input
                            type="checkbox"
                            id="checkBox01"
                            name="acceptedTerms"
                            checked={formData.acceptedTerms}
                            onChange={handleChange}
                          />
                          <label htmlFor="checkBox01">
                            <span className="check"></span>
                            <span className="box"></span> I accept the privacy
                            and terms.
                          </label>
                        </div>
                      </div>
                      <div className="tt-btn tt-btn__wide">
                        <span className="mask">Send Question</span>
                        <button type="submit" className="button">
                          Send Question
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default HelpDesk;
